import './AnimatedGradientLayer.css';
import { useBrowserDetection } from '../hooks/useBrowserDetection';
  
const AnimatedGradientLayer = () => {
  const { isSafariIOS } = useBrowserDetection();

  return (
    <div className="fixed bottom-0 left-0 right-0 h-[30vh] pointer-events-none z-0">
      
      {/* Degradado animado */}
      <div className="gradient-container">
        <div className={`gradient-ellipse bg-gradient ${isSafariIOS ? '' : 'bg-gradient-animated'}`}></div>
      </div>
      
    </div>
  );
};

export default AnimatedGradientLayer;
